import { SOLVED_AT } from '../game/progress';

interface Props {
  score: number;
}

/**
 * Rotated stamp across the score card.
 *
 * Purely decorative — the number and the rating already say the same thing, so
 * it is hidden from assistive tech rather than repeating them. It also stays
 * out of the way on narrow screens, where a three-digit score needs the room.
 */
export function VerdictStamp({ score }: Props) {
  const solved = score >= SOLVED_AT;
  return (
    <span
      className={`stamp ${solved ? 'stamp--closed' : 'stamp--cold'}`}
      aria-hidden="true"
    >
      {solved ? 'Case closed' : 'Cold case'}
    </span>
  );
}
